module.exports = __webpack_public_path__ + "img/57553F_C6C3AF_8C8768_868C8C-256px.73f954c9.png";